//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';
//@ts-ignore
class CustomSticker extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'CustomSticker';
  }
}
CustomSticker.initClass();

export { CustomSticker };
